// NPM
window.$ = window.jQuery = require('jquery');
const slick = require('slick-carousel');
const jqueryui = require('jquery-ui');
const bootstrap = require('bootstrap-sass');


 $(document).ready(function() {
     // search page
     if($('#searchfield').val() != '') {
         $('#searchclear').removeClass('d-n');
     } else {
         $('#searchclear').addClass('d-n');
     }

     $('#searchclear').click(function() {
         $('#searchfield').val('');
         $('#searchclear').addClass('d-n');
     });
     $('.search-container').on('keyup keypress blur change', function() {
         if($('#searchfield').val() != '') {
             $('#searchclear').removeClass('d-n');
         } else {
             $('#searchclear').addClass('d-n');
         }
     });

     // About us slide toggle
     $('.aboutus-card a.more').click(function() {
        $(this).next('div.more-details').slideToggle();
     });

     // responsive nav on the menu bar
     var el = $("#jumpnav option[data-guid='" + localized.guid + "']");
     var current_page_selected = $("#jumpnav option[data-title='" + localized.title + "']").val();
     $("#jumpnav").val(current_page_selected);


     $('#jumpnav').change(function() {
        var page_url = $(this).val();
        window.location.href = page_url;
     });

     // slick carousel
     $('.th-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
    	arrows: true,
        infinite: true,
        cssEase: 'linear',
    	prevArrow:"<i class='fa fa-angle-double-left' aria-hidden='true'></i>",
        nextArrow:"<i class='fa fa-angle-double-right' aria-hidden='true'></i>",
        autoplay: true
    });

    showOrHideProductsSlider();
    $(window).resize(function() {
        showOrHideProductsSlider();
    });

 });

function showOrHideProductsSlider() {
    if($(window).width() > 765) {
        // products carousel
        $('.products-slider').show();
        $('.products-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            cssEase: 'linear',
            fade: true,
            autoplay: true
        });
    } else {
        $('.products-slider').hide();
    }
}
